import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@glu/theming';
import styles from './sendPayment.styles';
import { numberToCurrency } from '../../utils/currency';

function Amount({ amount, classes }) {
  return (
    <div aria-live="polite" className={classes.total} data-qa="workflow-amount">
      {amount && numberToCurrency(amount)}
    </div>
  );
}

Amount.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  classes: PropTypes.objectOf(PropTypes.string).isRequired
};

Amount.defaultProps = {
  amount: '0.00'
};

export default withStyles(styles)(Amount);
